export function initialize() {
    $('.js-scrool-left').each(function() {
        var area = $(this).find('.js-scrool-area');

		var imageCount = area.find('img').length;
		var imageLoaded = 0;

		$(this).find('img').on('load', function() {
			imageLoaded += 1;

			if(imageLoaded === imageCount) {
                var areaClone = area.clone();
                area.after(areaClone);

                var areaDOM = area.get(0);
                var areaCloneDOM = areaClone.get(0);

                var areaLimit = 100000;
                var areaCounter = 0;
                var areaCloneCounter = 0;
				areaLimit = area.width();

				setInterval(function() {
					areaCounter -= 1;
					areaCloneCounter -= 1;

					areaDOM.style.left = areaCounter+'px';
					areaCloneDOM.style.left = areaCloneCounter+'px';

					if(areaCounter < -1 * areaLimit) {
						areaDOM.style.left = areaLimit+'px';
						areaCounter = areaLimit;
					}

					if(areaCloneCounter < -2 * areaLimit) {
						areaDOM.style.left = '0px';
						areaCloneCounter = 0;
					}
				}, 20);
			}
		}).each(function() {
		  if(this.complete) $(this).load();
		});

    });
}

export default {};

